<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
body{
	width: 100%;
	height: 100%;
	background: white;
}
</style>



// WEBPACK FOOTER //
// App.vue?3bc9c080